import { Controller } from "@hotwired/stimulus"

// Client-side inline search for an already-rendered table. Filters `row`
// targets by matching the trimmed/lowercased input against each row's
// `data-inline-search-text`. Toggles a clear (×) button, the search icon,
// and a "no matches" row.
//
// Progressive enhancement over the server-side Ransack form: with JS on,
// typing filters instantly with no reload; the surrounding <form> still
// submits a real server search without JS (and on Enter).
export default class extends Controller {
  static targets = ["input", "row", "empty", "clear", "icon"]
  static values = { resetUrl: String, serverQuery: Boolean }

  connect() {
    this.filter()
  }

  filter() {
    const query = (this.hasInputTarget ? this.inputTarget.value : "").trim().toLowerCase()
    let visible = 0

    this.rowTargets.forEach((row) => {
      const text = (row.dataset.inlineSearchText || row.textContent || "").toLowerCase()
      const match = query === "" || text.includes(query)
      row.classList.toggle("hidden", !match)
      if (match) visible += 1
    })

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", visible !== 0)
    if (this.hasClearTarget) this.clearTarget.classList.toggle("hidden", query === "")
    if (this.hasIconTarget) this.iconTarget.classList.toggle("hidden", query !== "")
  }

  clear() {
    // If we arrived from a server-side search (?q=…), only the matching subset
    // was rendered — so a true "clear" has to reload the full list.
    if (this.serverQueryValue && this.resetUrlValue) {
      window.location.href = this.resetUrlValue
      return
    }

    if (this.hasInputTarget) {
      this.inputTarget.value = ""
      this.inputTarget.focus()
    }
    this.filter()
  }
}
